import { PAGING_DEFAULT } from 'redhotpie-shared-lib/constants/constants';
import { IAlbumParams } from 'redhotpie-shared-lib/interfaces/IGroup';
import alertNotification from 'redhotpie-shared-lib/models/alertNotification';
import { GroupAlert } from 'redhotpie-shared-lib/models/groupAlert';
import InviteResponse from 'redhotpie-shared-lib/models/inviteResponse';
import groupApi from '../api/groupApi';
import { createFormDataComment, generateBodyComment, generateParamsCreateGroup } from '../functions/utils';
import { IParams, IParamsRequest } from '../interfaces/IAction';
import { IApiResponse } from '../interfaces/IApiResponse';
import { ClubMediaSortOrder } from '../interfaces/IGroup';
import AlbumDetail from '../models/albumDetail';
import clubEvents from '../models/clubEvents';
import clubVoteComments, { IClubVoteComments } from '../models/clubVoteComments';
import { Comments, CommentsItems } from '../models/comments';
import CommunityLikeUser from '../models/communityUser';
import Group from '../models/group';
import GroupDetailOwner from '../models/groupDetailOwner';
import GroupDetail from '../models/groupDetails';
import HomeClubReviewList from '../models/homeClubReviewList';
import { default as Feed, default as newFeedItem } from '../models/newFeedItem';
import { PagingInfo } from '../models/pagingInfo';
import Tag from '../models/tag';
import User from '../models/user';
import { GroupFullDetail, ICreateGroupParams, IGroupMedia, ILookUpTagsParams, ISearchGroups } from '../types/clubProfile';
import Friend from 'redhotpie-shared-lib/models/friends';

class groupService {
  generateBodyGetList(params?: IParams) {
    const body: any = {
      Size: params?.size ?? 20,
      Page: params?.page ?? 1,
    };
    if (params?.id) {
      body.ID = params.id;
    }
    return body;
  }

  getJoinedGroup() {
    return groupApi.getJoinedGroup().then(res => {
      try {
        if (res.success) {
          return {
            success: true,
            data: Group.mappingObjects(res.data.items),
            total: res.data.Total,
          };
        }
        return { success: false, data: [], message: res.message };
      } catch (e) {
        console.log('ERROR: groupService/getJoinedGroup:', e);
        throw new Error('failed');
      }
    });
  }

  getMyGroup() {
    return groupApi.getMyGroup().then(res => {
      try {
        if (res.success) {
          return {
            success: true,
            data: Group.mappingObjects(res.data.items),
            total: res.data.Total,
          };
        }
        return { success: false, data: [], message: res.message };
      } catch (e) {
        console.log('ERROR: groupService/getGroupsChat:', e);
        throw new Error('failed');
      }
    });
  }

  getRecommendedGroups(params: IParamsRequest) {
    return groupApi.getRecommendedGroups(params).then(res => {
      console.log('res', res);
      try {
        if (res.success) {
          return {
            success: true,
            data: Group.mappingObjects(res.data.Result),
            total: res.data.Total,
          };
        }
        return { success: false, data: [], message: res.message };
      } catch (e) {
        console.log('ERROR: groupService/getGroupsChat:', e);
        throw new Error('failed');
      }
    });
  }

  getGroupDetail(clubId: string, isOwner: boolean): Promise<IApiResponse<GroupFullDetail | GroupDetailOwner | {}>> {
    return groupApi.getGroupDetail(clubId, isOwner).then(res => {
      try {
        if (res.success) {
          return {
            success: true,
            data: isOwner ? GroupDetailOwner.mappingObjectOwner(res.data) : GroupDetail.mappingObject(res.data),
          };
        }
        return {
          success: false,
          message: res.message,
        };
      } catch (err) {
        console.log('error in groupService/getGroupDetail', err);
        return {
          success: false,
          message: res.message,
        };
      }
    });
  }

  searchGroups(body: ISearchGroups) {
    let _body = {
      ...body,
      page: body.page || 1,
      size: body.size || 25,
    };
    return groupApi.searchGroups(_body).then(res => {
      try {
        if (res.success) {
          return {
            success: true,
            data: Group.mappingObjects(res.data.Result || res.data.items),
            total: res.data.Total,
          };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/searchPopularGroup', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  searchPopularGroups(body: ISearchGroups) {
    let _body = {
      ...body,
      page: body.page || 1,
      size: body.size || 25,
    };
    return groupApi.searchPopularGroups(_body).then(res => {
      try {
        if (res.success) {
          return {
            success: true,
            data: Group.mappingObjects(res.data.Data),
            total: res.data.Total,
          };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/searchPopularGroup', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  searchGroupByName(name: string) {
    return groupApi.searchGroupByName(name).then(res => {
      try {
        if (res.success) {
          return {
            success: true,
            data: Group.mappingObjects(res.data.Data),
            total: res.data.Total,
          };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/searchGroupByName', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  getClubVoteComments(params: IParamsRequest): Promise<IApiResponse<IClubVoteComments>> {
    return groupApi.getClubVoteComments(params).then(res => {
      try {
        return {
          success: res.success,
          data: res.data && clubVoteComments.mappingObject(res.data),
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR: groupService/getClubVoteComments:', res);
        return {
          success: false,
          message: 'ERROR: groupService/getClubVoteComments',
        };
      }
    });
  }

  getAllGroupReviews(params?: { size?: number; page?: number }) {
    const body = {
      size: params && params.size ? params.size : 20,
      page: params && params.page ? params.page : 1,
    };
    return groupApi.getAllGroupReviews(body).then(res => {
      try {
        if (res.success) {
          return {
            success: true,
            data: HomeClubReviewList.mapAllReviewList(res.data.Data),
            paginationInfo: {
              totalPage: Math.ceil(res.data.Total / (params && params.size ? params.size : 20)),
              total: res.data.Total,
            },
          };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/getAllGroupReviews', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  getGroupJoinedUsers(clubID: string, params?: { size?: number; page?: number; searchUserName?: string; memberTypes?: number }) {
    const body = {
      Size: params && params.size ? params.size : 20,
      Page: params && params.page ? params.page : 1,
      SearchUserName: params && params.searchUserName ? params.searchUserName : '',
      MemberTypes: params && params.memberTypes ? params.memberTypes : -1,
    };
    return groupApi.getGroupJoinedUsers(clubID, body).then(res => {
      try {
        if (res.success) {
          return {
            success: true,
            data: User.mappingObjectsCustom(res.data.Data),
            paginationInfo: new PagingInfo(res.data.PaginationInfo),
          };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/getGroupJoinedUsers', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  getGroupEvents(params: {
    clubId: string;
    isOwner: boolean;
    isApprovedOnly?: boolean;
    page?: number;
    size?: number;
    type?: string;
  }): Promise<IApiResponse> {
    return groupApi.getGroupEvents(params).then(res => {
      try {
        if (params.isOwner) {
          return {
            success: res.success,
            data: res.data && clubEvents.mappingObject({ Data: res.data.items, Total: 0 }),
            message: res.message,
          };
        }
        return {
          success: res.success,
          data: res.data && clubEvents.mappingObject(res.data),
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR: groupService/getGroupEvents:', res);
        return { success: false, message: 'ERROR: groupService/getGroupEvents' };
      }
    });
  }

  postGroupComment(params: any) {
    return groupApi.postGroupComment(params).then(res => {
      try {
        if (res.success) {
          return { success: true, data: res.data };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/postGroupComment', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  searchGroupByTagName(name: string) {
    return groupApi.searchGroupByTagName(name).then(res => {
      try {
        // console.log('searchGroupByTagName', res);
        if (res.success) {
          return {
            success: true,
            data: Tag.mappingArray(res.data.items || []),
          };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/searchGroupByTagName', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  postGroupVote(clubID: string, params: any) {
    return groupApi.postGroupVote(clubID, params).then(res => {
      try {
        if (res.success) {
          return { success: true, data: res.data };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/postGroupVote', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  joinAGroup(clubID: string) {
    return groupApi.joinAGroup(clubID).then(res => {
      console.log('joinAGroup', res);
      try {
        if (res.success) {
          return { success: true, data: res.data?.MemberStatus };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/joinAGroup', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  acceptInvitationJoinGroup(clubID: string) {
    return groupApi.acceptInvitationJoinGroup(clubID).then(res => {
      try {
        if (res.success) {
          return { success: true, data: res.data };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/acceptInvitationJoinGroup', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  rejectInvitationJoinGroup(clubID: string) {
    return groupApi.rejectInvitationJoinGroup(clubID).then(res => {
      try {
        if (res.success) {
          return { success: true, data: res.data };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/rejectInvitationJoinGroup', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  leaveAGroup(clubID: string) {
    return groupApi.leaveAGroup(clubID).then(res => {
      try {
        if (res.success) {
          return { success: true, data: res.data };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/leaveAGroup', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  getListUserRequestJoinClub(clubID: string, params: { searchUserName?: string; matching?: number; page?: number; size?: number }) {
    return groupApi.getListUserRequestJoinClub(clubID, params).then(res => {
      try {
        if (res.success) {
          return {
            success: true,
            data: User.mappingObjectsCustom(res.data.Data || []),
            paginationInfo: new PagingInfo(res.data.PaginationInfo),
            totalRequests: res.data.TotalRequests,
          };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/getListUserRequestJoinClub', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  patchApproveUserJoinGroupRequest(clubID: string, params: {}) {
    return groupApi.patchApproveUserJoinGroupRequest(clubID, params).then(res => {
      try {
        if (res.success) {
          return { success: true, data: res.data };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/patchApproveUserJoinGroupRequest', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  patchRemoveUserJoinGroupRequest(clubID: string, params: {}) {
    return groupApi.patchRemoveUserJoinGroupRequest(clubID, params).then(res => {
      try {
        if (res.success) {
          return { success: true, message: '' };
        }
        return { success: false, message: res.message };
      } catch (err) {
        console.log('error in groupService/patchRemoveUserJoinGroupRequest', err);
        return { success: false, message: err };
      }
    });
  }

  patchClubUserMemberLevel(clubID: string, userID: string, params: { clubMemberType: string }) {
    const _params = {
      MemberType: params.clubMemberType,
    };
    return groupApi.patchClubUserMemberLevel(clubID, userID, _params).then(res => {
      try {
        if (res.success) {
          return { success: true, data: res.data };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/patchClubUserMemberLevel', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  patchClubUserBanPosting(
    clubID: string,
    userID: string,
    params: {
      isBanned: boolean;
    }
  ) {
    return groupApi.patchClubUserBanPosting(clubID, userID, params).then(res => {
      try {
        if (res.success) {
          return { success: true, data: res.data };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/patchClubUserBanPosting', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  searchGroupByTagId(tagId: number, params: IParamsRequest) {
    return groupApi.searchGroupByTagId(tagId, params).then(res => {
      try {
        if (res.success) {
          return { success: true, data: Group.mappingObjects(res.data.Data) };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/searchGroupByTagId', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  joinAPrivateGroup(clubID: string) {
    return groupApi.joinAPrivateGroup(clubID).then(res => {
      try {
        if (res.success) {
          return { success: true, data: res.data };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/joinAPrivateGroup', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  leaveAPrivateGroup(clubID: string) {
    return groupApi.leaveAPrivateGroup(clubID).then(res => {
      try {
        if (res.success) {
          return { success: true, data: res.data };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/leaveAPrivateGroup', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  getGroupActivity(params: { clubId: string; isOwner: boolean; page?: number; size?: number }) {
    return groupApi.getGroupActivity(params).then((res: { success: any; data: any; message: any }) => {
      try {
        if (res.success) {
          return {
            success: true,
            data: newFeedItem.mappingObjects(res.data.items || []) || [],
          };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/getGroupPost', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  getGroupAlbums(params: { clubId: string; isOwner: boolean; page?: number; size?: number }) {
    return groupApi.getGroupAlbums(params).then((res: { success: any; data: any; message: any }) => {
      try {
        if (res.success) {
          return {
            success: true,
            data: GroupDetail.mappingGroupAlbums(res.data.Data),
            paginationInfo: new PagingInfo(res.data.PaginationInfo),
          };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/getGroupAlbums', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  getGroupPhotos(params: { clubId: string; isOwner: boolean; page?: number; size?: number }) {
    return groupApi.getGroupPhotos(params).then(res => {
      try {
        if (res.success) {
          return {
            success: true,
            data: GroupDetail.mappingGroupMedias(res.data.Data),
            paginationInfo: new PagingInfo(res.data.PaginationInfo),
          };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/getGroupPhotos', err);
        return { success: false, data: [], message: err, paginationInfo: new PagingInfo() };
      }
    });
  }

  getGroupVideos(params: { clubId: string; isOwner: boolean; page?: number; size?: number }) {
    return groupApi.getGroupVideos(params).then((res: IApiResponse) => {
      try {
        if (res.success) {
          return {
            success: true,
            data: GroupDetail.mappingGroupMedias(res.data.Data),
            paginationInfo: new PagingInfo(res.data.PaginationInfo),
          };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/getGroupVideos', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  lookupGroupTags(params: ILookUpTagsParams) {
    return groupApi.lookupGroupTags(params).then(res => {
      try {
        return {
          success: true,
          data: res.items ? Tag.mappingArray(res.items) : [],
        };
      } catch (err) {
        console.log('error in groupService/lookupGroupTags', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  createGroup(params: ICreateGroupParams) {
    const newParams = generateParamsCreateGroup(params);
    return groupApi.createGroup(newParams).then(res => {
      try {
        if (res.success) {
          return {
            success: true,
            data: Group.mappingCreateGroupObject(res.data),
          };
        }
        return { success: false, message: res.message };
      } catch (err) {
        console.log('error in groupService/createGroup', err);
        return { success: false, message: err };
      }
    });
  }

  postGroupBanner(clubId: string, body: any) {
    return groupApi.postClubBanner(clubId, body).then(res => {
      if (res.success) {
        return { success: true, data: GroupDetail.mappingPhoto(res.data) };
      }
      return { success: false, data: [], message: res.message };
    });
  }

  updateGroup(clubId: string, params: ICreateGroupParams) {
    const newParams = generateParamsCreateGroup(params);
    return groupApi.updateGroup(clubId, newParams).then(res => {
      try {
        return {
          success: true,
          data: Group.mappingObject(res.data),
        };
      } catch (err) {
        console.log('error in groupService/updateGroup', err);
        return { success: false, message: err };
      }
    });
  }

  removeGroup(clubId: string) {
    return groupApi.removeGroup(clubId).then(res => {
      return res;
    });
  }

  postMediaLike = (id: number | string) => {
    return groupApi
      .postMediaLike(id)
      .then((res: IApiResponse<any>) => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: CommunityLikeUser.mappingUser(res.data),
            };
          }
        }
        console.error('ERROR: groupServices/postLikeMedia:', res);
        return { success: res.success, data: {}, message: res.message };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/postLikeMedia:', e);
        return { success: false, data: {}, message: e };
      });
  };
  deleteMediaLike = (id: number | string) => {
    return groupApi
      .deleteMediaLike(id)
      .then((res: IApiResponse<any>) => {
        if (res.success) {
          if (res.data) {
            return { success: res.success };
          }
        }
        console.error('ERROR: groupServices/deleteMediaLike:', res);
        return { success: res.success, data: {}, message: res.message };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/deleteMediaLike:', e);
        return { success: false, data: {}, message: e };
      });
  };
  postAlbumLike = (id: number | string) => {
    return groupApi
      .postAlbumLike(id)
      .then((res: IApiResponse<any>) => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: CommunityLikeUser.mappingUser(res.data),
            };
          }
        }
        console.error('ERROR: groupServices/postLikeMedia:', res);
        return { success: res.success, data: {}, message: res.message };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/postLikeMedia:', e);
        return { success: false, data: {}, message: e };
      });
  };
  deleteAlbumLike = (id: number | string) => {
    return groupApi
      .deleteAlbumLike(id)
      .then((res: IApiResponse<any>) => {
        if (res.success) {
          if (res.data) {
            return { success: res.success };
          }
        }
        console.error('ERROR: groupServices/deleteMediaLike:', res);
        return { success: res.success, data: {}, message: res.message };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/deleteMediaLike:', e);
        return { success: false, data: {}, message: e };
      });
  };

  getMediaComment(params: IParams): Promise<IApiResponse<any>> {
    const body = this.generateBodyGetList(params);
    return groupApi
      .getClubMediaComment(body)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: Comments.mappingObject(res.data),
            };
          }
          return { success: res.success, data: {} as Comments };
        }
        console.error('ERROR: groupServices/getMediaComment:', res);
        return { success: res.success, data: {} as Comments };
      })
      .catch(e => {
        console.error('ERROR: groupServices/getMediaComment:', e);
        return { success: false, data: {} as Comments };
      });
  }

  postCreateMediaComment(params: IParams): Promise<IApiResponse<any>> {
    let body = generateBodyComment(params);
    body = createFormDataComment(params, body);
    return groupApi
      .postClubMediaComment({ body, ID: params.id })
      .then((res: IApiResponse<any>) => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: CommentsItems.mappingObject(res.data),
            };
          }
        }
        console.error('ERROR: groupServices/postCreateMediaComment:', res);
        return { success: res.success, message: res.message };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/postCreateMediaComment:', e);
        return { success: false, data: {} };
      });
  }

  getAlbumComment(params: IParams): Promise<IApiResponse<any>> {
    const body = this.generateBodyGetList(params);
    return groupApi
      .getClubAlbumComment(body)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: Comments.mappingObject(res.data),
            };
          }
          return { success: res.success, data: {} as Comments };
        }
        console.error('ERROR: groupServices/getAlbumComment:', res);
        return { success: res.success, data: {} as Comments };
      })
      .catch(e => {
        console.error('ERROR: groupServices/getAlbumComment:', e);
        return { success: false, data: {} as Comments };
      });
  }

  postCreateAlbumComment(params: IParams): Promise<IApiResponse<any>> {
    let body = generateBodyComment(params);
    body = createFormDataComment(params, body);
    return groupApi
      .postClubAlbumComment({ body, ID: params.id })
      .then((res: IApiResponse<any>) => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: CommentsItems.mappingObject(res.data),
            };
          }
        }
        console.error('ERROR: groupServices/postCreateAlbumComment:', res);
        return { success: res.success, message: res.message };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/postCreateAlbumComment:', e);
        return { success: false, data: {} };
      });
  }

  getUserClubFriend(clubID: string) {
    const body = {
      Size: 25,
      Page: 1,
    };
    return groupApi.getUserClubFriend(clubID, body).then(res => {
      try {
        if (res.success) {
          return {
            success: true,
            data: User.mappingObjectsCustom(res.data.Data),
          };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/getUserClubFriend', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  getMediaLike = (params: { id: number; page?: number; size?: number }) => {
    return groupApi
      .getMediaLike(params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: CommunityLikeUser.mappingUsers(res.data.items),
            };
          }
          return { success: res.success, data: [] as CommunityLikeUser[] };
        }
        console.log('ERROR: groupServices/getMediaLike:', res);
        return { success: res.success, data: [] as CommunityLikeUser[] };
      })
      .catch(e => {
        console.warn('ERROR: groupServices/getMediaLike:', e);
        return { success: false, data: [] as CommunityLikeUser[] };
      });
  };
  getAlbumLike = (params: { id: number; page?: number; size?: number }) => {
    return groupApi
      .getAlbumLike(params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: CommunityLikeUser.mappingUsers(res.data.items),
            };
          }
          return { success: res.success, data: [] as CommunityLikeUser[] };
        }
        console.log('ERROR: groupServices/getMediaLike:', res);
        return { success: res.success, data: [] as CommunityLikeUser[] };
      })
      .catch(e => {
        console.warn('ERROR: groupServices/getMediaLike:', e);
        return { success: false, data: [] as CommunityLikeUser[] };
      });
  };

  getGroupAlbumMedia(params: { albumId: string; isOwner: boolean; page?: number; size?: number }) {
    return groupApi.getGroupAlbumMedia(params).then((res: { success: any; data: any; message: any }) => {
      try {
        if (res.success) {
          return {
            success: true,
            data: GroupDetail.mappingGroupMedias(res.data.Data),
            paginationInfo: new PagingInfo(res.data.PaginationInfo),
          };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/getGroupAlbums', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  getGroupTagPopular(): Promise<IApiResponse<any>> {
    return groupApi.getGroupTagPopular().then((res: IApiResponse) => {
      try {
        return {
          success: res.success,
          data:
            res?.data?.items.map((item: { TagID: any; Keyword: any }) => ({
              tagId: item.TagID,
              keyWord: item.Keyword,
            })) || [],
        };
      } catch (err) {
        console.log('error in groupService/getGroupAlbums', err);
        return { success: false, data: [], message: err?.toString() || '' };
      }
    });
  }
  getUserClubAlertByClubID(clubID: string) {
    return groupApi.getUserClubAlertByClubID(clubID).then(res => {
      try {
        return { success: true, data: { items: GroupAlert.mappingObjects(res?.Alerts || []), count: res?.Count || 0 } };
      } catch (err) {
        console.log('error in groupService/getUserClubAlert', err);
        return { success: false, data: { items: [], count: 0 }, message: err };
      }
    });
  }
  getGroupUserActivites(clubID: string, params: { page?: number; pageSize?: number } = { page: 1, pageSize: 100 }) {
    return groupApi.getGroupUserActivites(clubID, params).then(res => {
      try {
        return {
          success: res.status === 200,
          data: GroupDetail.mappingClubAlerts(res.data.Interactions),
          paginationInfo: PagingInfo.mappingObject(res.data),
        };
      } catch (err) {
        console.log('error in groupService/getGroupAlbums', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  getGroupEventExpressInterest(clubID: string, params: { page?: number; pageSize?: number } = { page: 1, pageSize: 100 }) {
    return groupApi.getGroupEventExpressInterest(clubID, params).then(res => {
      console.log('groupService getGroupEventExpressInterest', res);
      try {
        return {
          success: res.status === 200,
          data: alertNotification.mappingListEventInterest(res.data.Data),
          total: res.data.Total,
        };
      } catch (err) {
        console.log('error in groupService/getGroupAlbums', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  getClubPostComment(params: IParams): Promise<IApiResponse<any>> {
    const body = this.generateBodyGetList(params);
    return groupApi
      .getClubPostComment(body)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: Comments.mappingObject(res.data),
            };
          }
          return { success: res.success, data: {} as Comments };
        }
        console.error('ERROR: groupServices/getClubPostComment:', res);
        return { success: res.success, data: {} as Comments };
      })
      .catch(e => {
        console.error('ERROR: groupServices/getClubPostComment:', e);
        return { success: false, data: {} as Comments };
      });
  }

  postClubPostComment(params: IParams): Promise<IApiResponse<any>> {
    let body = generateBodyComment(params);
    body = createFormDataComment(params, body);
    return groupApi
      .postClubPostComment({ body, ID: params.id })
      .then((res: IApiResponse<any>) => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: CommentsItems.mappingObject(res.data),
            };
          }
        }
        console.error('ERROR: groupServices/postClubPostComment:', res);
        return { success: res.success, message: res.message };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/postClubPostComment:', e);
        return { success: false, data: {} };
      });
  }

  getClubPostLikes = (params: IParams) => {
    let body = generateBodyComment(params);
    body = createFormDataComment(params, body);
    return groupApi
      .getClubPostLikes(body)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: CommunityLikeUser.mappingUsers(res.data.items),
            };
          }
          return { success: res.success, data: [] as CommunityLikeUser[] };
        }
        console.log('ERROR: groupServices/getClubPostLikes:', res);
        return { success: res.success, data: [] as CommunityLikeUser[] };
      })
      .catch(e => {
        console.warn('ERROR: groupServices/getClubPostLikes:', e);
        return { success: false, data: [] as CommunityLikeUser[] };
      });
  };
  postClubPostLike = (id: number | string) => {
    return groupApi
      .postClubPostLike(id)
      .then((res: IApiResponse<any>) => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: CommunityLikeUser.mappingUser(res.data),
            };
          }
        }
        console.error('ERROR: groupServices/postClubPostLike:', res);
        return { success: res.success, data: {}, message: res.message };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/postClubPostLike:', e);
        return { success: false, data: {}, message: e };
      });
  };
  postInviteUserToJoinGroup = (clubId: number | string, userId: number | string) => {
    return groupApi
      .postInviteUserToJoinGroup(clubId, userId)
      .then((res: IApiResponse<any>) => {
        return res;
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/postInviteUserToJoinGroup:', e);
        return { success: false, data: {}, message: e };
      });
  };
  postAcceptInvitationJoinGroup = (clubId: number | string) => {
    return groupApi
      .postAcceptInvitationJoinGroup(clubId)
      .then((res: IApiResponse<any>) => {
        return res;
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/postAcceptInvitationJoinGroup:', e);
        return { success: false, data: {}, message: e };
      });
  };
  postRejectInvitationJoinGroup = (clubId: number | string) => {
    return groupApi
      .postRejectInvitationJoinGroup(clubId)
      .then((res: IApiResponse<any>) => {
        return res;
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/postRejectInvitationJoinGroup:', e);
        return { success: false, data: {}, message: e };
      });
  };
  deleteClubPostLike = (id: number | string) => {
    return groupApi
      .deleteClubPostLike(id)
      .then((res: IApiResponse<any>) => {
        if (res.success) {
          if (res.data) {
            return { success: res.success };
          }
        }
        console.error('ERROR: groupServices/deleteClubPostLike:', res);
        return { success: res.success, data: {}, message: res.message };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/deleteClubPostLike:', e);
        return { success: false, data: {}, message: e };
      });
  };
  getClubPostDetail = ({ id, isOwner }: { id: number | string; isOwner: boolean }) => {
    return groupApi
      .getClubPostDetail({ id, isOwner })
      .then((res: IApiResponse<any>) => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: GroupDetail.mappingGroupPostDetail(res.data),
            };
          }
        }
        console.error('ERROR: groupServices/getClubPostDetail:', res);
        return { success: res.success, data: null };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/getClubPostDetail:', e);
        return { success: false, data: null };
      });
  };
  createClubPost = (params: { clubId: string | number; message: string; eventId?: number }) => {
    return groupApi
      .createClubPost(params)
      .then((res: IApiResponse<any>) => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: GroupDetail.mappingGroupPostDetail(res.data),
            };
          }
        }
        console.error('ERROR: groupServices/createClubPost:', res);
        return { success: res.success, data: {} };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/createClubPost:', e);
        return { success: false, data: {} };
      });
  };
  editClubPost = (params: { postId: string | number; message: string; eventId?: string | number }) => {
    return groupApi
      .editClubPost(params)
      .then((res: IApiResponse<any>) => {
        console.log('groupService editClubPost', res);
        if (res.success) {
          if (res.data) {
            return { success: res.success, data: res.data };
          }
        }
        console.error('ERROR: groupServices/editClubPost:', res);
        return { success: res.success, data: {} };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/editClubPost:', e);
        return { success: false, data: {} };
      });
  };
  deletePost = (id: number | string) => {
    return groupApi
      .deleteClubPost(id)
      .then((res: IApiResponse<any>) => {
        if (res.success) {
          if (res.data) {
            return { success: res.success };
          }
        }
        console.error('ERROR: groupServices/deletePost:', res);
        return { success: res.success, data: {} };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/deletePost:', e);
        return { success: false, data: {} };
      });
  };
  getAlbumDetail = (params: IAlbumParams) => {
    return groupApi
      .getAlbumDetail(params)
      .then(res => {
        return {
          success: res.success,
          data: AlbumDetail.mappingObject(res.data),
        };
      })
      .catch((e: any) => {
        console.log('ERROR: groupServices/getAlbumDetail: ', e);
        return { success: false, data: null };
      });
  };
  createClubAlbum = (params: { clubId: string | number; title: string }) => {
    return groupApi
      .createClubAlbum(params)
      .then((res: IApiResponse<any>) => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: AlbumDetail.mappingObject(res.data),
            };
          }
        }
        console.error('ERROR: groupServices/createClubAlbum:', res);
        return { success: res.success, data: {} };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/createClubAlbum:', e);
        return { success: false, data: {} };
      });
  };
  editClubAlbum = (params: { albumId: string | number; title: string }) => {
    return groupApi
      .editClubAlbum(params)
      .then((res: IApiResponse<any>) => {
        if (res.success) {
          if (res.data) {
            return { success: res.success, data: AlbumDetail.mappingObject(res.data) };
          }
        }
        console.error('ERROR: groupServices/editClubAlbum:', res);
        return { success: res.success, data: {} };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/editClubAlbum:', e);
        return { success: false, data: {} };
      });
  };
  deleteAlbum = (id: number | string) => {
    return groupApi
      .deleteClubAlbum(id)
      .then((res: IApiResponse<any>) => {
        if (res.success) {
          if (res.data) {
            return { success: res.success };
          }
        }
        console.error('ERROR: groupServices/deleteAlbum:', res);
        return { success: res.success, data: {} };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/deleteAlbum:', e);
        return { success: false, data: {} };
      });
  };
  createClubMediaPhoto = (params: any) => {
    const formData = new FormData();
    // @ts-ignore
    formData.append('File', params.file);
    formData.append('ParentID', params.parentID);
    formData.append('ParentType', params.parentType);
    formData.append('SortNumber', params.sortNumber);
    return groupApi
      .createClubMediaPhoto(formData)
      .then((res: any) => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: GroupDetail.mappingGroupMedia(res.data),
              errorCode: '',
              message: '',
            };
          }
        }
        console.error('ERROR: groupServices/createClubMediaPhoto:', res);
        return { success: res.success, data: {}, errorCode: res.statusCode, message: res.message };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/createClubMediaPhoto:', e);
        return { success: false, data: {}, errorCode: '4005', message: e };
      });
  };
  createClubMediaVideo = (params: any) => {
    return groupApi.createClubMediaVideo(params);
  };
  deleteClubMedia = (mediaId: number | string) => {
    return groupApi
      .deleteClubMedia(mediaId)
      .then((res: any) => {
        if (res.success) {
          if (res.data) {
            return { success: res.success };
          }
        }
        console.error('ERROR: groupServices/deleteClubMedia:', res);
        return { success: res.success, data: {} };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/deleteClubMedia:', e);
        return { success: false, data: {} };
      });
  };

  deleteClubPostMedias = (postId: number, mediaIds: number[]) => {
    return groupApi
      .deleteClubPostMedias(postId, mediaIds)
      .then((res: IApiResponse) => {
        console.log('deleteClubPostMedias', res);
        if (res.success) {
          return res;
        }
        return { success: false, message: res.message };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/deleteClubPostMedias:', e);
        return { success: false, message: e?.message };
      });
  };

  deleteClubAlbumMedias = (albumId: number, mediaIds: number[]) => {
    return groupApi
      .deleteClubAlbumMedias(albumId, mediaIds)
      .then((res: IApiResponse) => {
        console.log('deleteClubAlbumMedias', res);
        if (res.success) {
          return res;
        }
        return { success: false, message: res.message };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/deleteClubAlbumMedias:', e);
        return { success: false, message: e?.message };
      });
  };

  reOrderUserClubPostMedia = (postId: number, mediaOrder: ClubMediaSortOrder[]) => {
    return groupApi
      .reOrderUserClubPostMedia(postId, mediaOrder)
      .then((res: IApiResponse) => {
        if (res.success) {
          return res;
        }
        return { success: false, message: res?.message };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/reOrderUserClubPostMedia:', e);
        return { success: false, message: e?.message };
      });
  };

  reOrderUserClubAlbumMedia = (albumId: number, mediaOrder: ClubMediaSortOrder[]) => {
    return groupApi
      .reOrderUserClubAlbumMedia(albumId, mediaOrder)
      .then((res: IApiResponse) => {
        if (res.success) {
          return res;
        }
        return { success: false, message: res?.message };
      })
      .catch((e: any) => {
        console.error('ERROR: groupServices/reOrderUserClubAlbumMedia:', e);
        return { success: false, message: e?.message };
      });
  };

  getGroupPostMedia(params: { postId: any; page?: number; size?: number; isOwner?: boolean }) {
    return groupApi.getGroupPostMedia(params).then((res: { success: any; data: any; message: any }) => {
      try {
        if (res.success) {
          return {
            success: true,
            data: GroupDetail.mappingGroupMedias(res.data.Data),
            paginationInfo: new PagingInfo(res.data.PaginationInfo),
          };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/getGroupAlbums', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  getClubListCanBeInvited(userId: number | string) {
    return groupApi.getClubListCanBeInvited(userId).then((res: any) => {
      try {
        if (res.success) {
          return {
            success: true,
            data: GroupDetail.mappingGroupCanInvited(res.data.items),
          };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/getGroupAlbums', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  getUserClubJoinedUsers(clubId: string, params: { page: number; size: number; SearchUserName: string }) {
    const body = {
      page: params.page || 1,
      size: params.size || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
      SearchUserName: params.SearchUserName || '',
    };
    return groupApi.getUserClubJoinedUsers(clubId, body).then((res: IApiResponse) => {
      try {
        if (res.success) {
          return {
            success: true,
            data: User.mappingObjectsCustom(res.data.Data || []),
            paginationInfo: new PagingInfo(res.data.PaginationInfo),
            totalRequests: res.data.TotalRequests,
          };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/getUserClubJoinedUsers', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  getClubMedia(mediaId: string, isOwner = false): Promise<IApiResponse<IGroupMedia[]>> {
    return groupApi
      .getClubMedia(mediaId, isOwner)
      .then((res: IApiResponse) => {
        // try {
        if (res.success) {
          return {
            success: true,
            data: GroupDetail.mappingGroupMedias([res.data]),
          };
        }
        return { success: false, data: [], message: res.message };
      })
      .catch(e => {
        console.log('error in groupService/getClubMedia', e);
        return { success: false, data: [], message: e || '' };
      });
  }
  deleteClubValidation(commentId: number, isOwner?: boolean) {
    return groupApi.deleteClubValidation(commentId, isOwner).then((res: IApiResponse) => {
      try {
        if (res.success) {
          return { success: true, data: res.data };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/deleteClubValidation', err);
        return { success: false, data: [], message: err };
      }
    });
  }
  deleteClubVote(voteId: number, clubId: string | number, isOwner: boolean) {
    let func = isOwner ? groupApi.deleteClubVoteOwner(voteId) : groupApi.deleteClubVote(voteId, clubId);
    return func.then((res: IApiResponse) => {
      try {
        if (res.success) {
          return { success: true, data: res.data };
        }
        return { success: false, data: [], message: res.message };
      } catch (err) {
        console.log('error in groupService/deleteClubVote', err);
        return { success: false, data: [], message: err };
      }
    });
  }
  postClubVote(params: { id: string | number; score: number; comment?: string }): Promise<IApiResponse> {
    const body: any = {
      ID: `${params.id}`,
      Score: params.score,
    };
    if (params.comment) {
      body.Comment = params.comment;
    }
    return groupApi.postClubVote(body).then(res => {
      try {
        return res;
      } catch (e) {
        console.log('ERROR: groupService/postClubVote:', res);
        return { success: false, message: 'ERROR: groupService/postClubVote' };
      }
    });
  }
  getUserClubAlert(params: { pageSize?: number; page?: number }) {
    return groupApi.getUserClubAlert(params).then(res => {
      try {
        return { success: true, data: GroupAlert.mappingObjects(res?.Alerts || []), total: res?.Count || 0 };
      } catch (err) {
        console.log('error in groupService/getUserClubAlert', err);
        return { success: false, data: { items: [], count: 0 }, message: err };
      }
    });
  }
  getGroupActivitiesNotification(params: { pageSize?: number; page?: number }) {
    return groupApi.getGroupActivitiesNotification(params).then(res => {
      try {
        return {
          success: true,
          data: GroupDetail.mappingClubAlerts(res.data.Interactions),
          total: res.data?.TotalItems || 0,
        };
      } catch (err) {
        console.log('error in groupService/getGroupActivitiesNotification', err);
        return { success: false, data: [], message: err };
      }
    });
  }
  getGroupJoinRequestNotification(params: { pageSize?: number; page?: number }) {
    return groupApi.getGroupJoinRequestNotification(params).then(res => {
      try {
        return {
          success: true,
          data: User.mappingObjectsCustomGroupJoinRequest(res.data.Data || []),
          total: res.data?.PaginationInfo?.TotalItems || 0,
        };
      } catch (err) {
        console.log('error in groupService/getGroupJoinRequestNotification', err);
        return { success: false, data: [], message: err };
      }
    });
  }
  getSuggestedUsers(params: {
    clubId: string;
    pageSize?: number;
    page?: number;
    memberType?: number;
    ageMax?: number;
    ageMin?: number;
  }): Promise<IApiResponse> {
    return groupApi.getSuggestedUsers(params).then(res => {
      try {
        return {
          success: true,
          data: User.mappingObjectsCustomMemberSearch(res.data.Data || []),
          total: res.data?.PaginationInfo?.TotalItems || 0,
        };
      } catch (err: any) {
        console.log('error in groupService/getSuggestedUsers', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  getGroupChatCount(params: { clubId: string }) {
    return groupApi.getGroupChatCount(params).then(res => {
      try {
        return { success: true, data: res.data };
      } catch (err) {
        console.log('error in groupService/getGroupChatCount', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  getGroupChats(params: { clubId: string }) {
    return groupApi.getGroupChats(params).then((res: IApiResponse) => {
      try {
        return { success: res.success, data: GroupDetail.mappingListGroupChatItem(res.data.items) };
      } catch (err) {
        console.log('error in groupService/getGroupChats', err);
        return { success: false, data: [], message: err };
      }
    });
  }
  getGroupRecentActivity(params?: { page?: number; size?: number }): Promise<IApiResponse<Feed[]>> {
    const _params = {
      page: params?.page || 1,
      size: params?.size || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
    };
    return groupApi
      .getGroupRecentActivity(_params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: newFeedItem.mappingObjects(res.data.items || []),
            };
          }
          return { success: res.success, data: [] };
        }
        console.log('ERROR: groupServices/getAllGroupActivity:', res);
        return res;
      })
      .catch(e => {
        console.warn('ERROR: groupServices/getAllGroupActivity:', e);
        return { success: false };
      });
  }

  getGroupReceivedInvites(
    params: IParamsRequest
  ): Promise<Pick<IApiResponse<InviteResponse[]>, 'data' | 'success' | 'message' | 'totalItems' | 'totalPages' | 'size' | 'page'>> {
    return groupApi.getGroupReceivedInvites(params).then(res => {
      try {
        return {
          success: res.success,
          data: InviteResponse.mappingObjects(res.data.Invites || []),
          totalItems: res.data.TotalItems || 0,
          totalPages: res.data.TotalPages || 0,
          size: res.data.Size || 25,
          page: res.data.Page || 1,
        };
      } catch (err: any) {
        console.log('error in groupService/getGroupReceivedInvites', err);
        return { success: false, data: [], message: err.message };
      }
    });
  }

  deleteGroupReceivedInvite(inviteId: number): Promise<IApiResponse> {
    return groupApi.deleteGroupReceivedInvite(inviteId).then(res => {
      return res;
    });
  }
  postBlockGroup(clubId: string): Promise<IApiResponse> {
    return groupApi.postBlockGroup(clubId).then(res => {
      return res;
    });
  }

  deleteUserClubEvent(clubId: string, eventId: number): Promise<IApiResponse> {
    return groupApi.deleteUserClubEvent(clubId, eventId).then(res => {
      return res;
    });
  }

  postCreateUserClubMediaVideoURL(body: any): Promise<IApiResponse> {
    const object = {
      ParentID: body.parentID,
      ParentType: body.parentType,
      SortNumber: body.sortNumber,
      VideoUrl: body.videoUrl,
      VideoCode: body.videoCode,
      VideoType: body.videoType,
      VideoThumbUrl: body.videoThumbUrl || '',
    };
    return groupApi.postCreateUserClubMediaVideoURL(object).then(res => {
      return res;
    });
  }

  getUserClubNewUsers(params: { pageSize?: number; page?: number; clubId?: string }): Promise<IApiResponse> {
    return groupApi.getUserClubNewUsers(params).then(res => {
      try {
        return {
          success: true,
          data: Friend.mappingObjects(res.data.Data),
          paginationInfo: PagingInfo.mappingObject(res.data.PaginationInfo),
        };
      } catch (err) {
        console.log('error in groupService/getGroupActivitiesNotification', err);
        return { success: false, data: [], message: (err as any) || '' };
      }
    });
  }
}

export default new groupService();
